import React, { useState } from 'react'
import { styles } from '../../../../../../styles/tailwind-config'
import { Label } from '../../../../../../components/ui/label'
import { Input } from '../../../../../../components/ui/input'
import { useInterventionInput } from '../../../../../../context/InterventionInputContext'
import { EditIcon } from 'lucide-react'
import { cn } from '../../../../../../lib/utils'
import { Trans } from '@lingui/react/macro'

const Customer = () => {
    const { intervention, setintervention } = useInterventionInput()

    const [is_edit, setis_edit] = useState(false);

  return (
    <div>
        <div className='flex items-center gap-4 mb-4 sm:justify-between'>
            <h3 className={`${styles.h3}`}><Trans>Klant informatie</Trans></h3>

            <button onClick={()=>{setis_edit(!is_edit)}} className={
                cn(
                    is_edit ? 'bg-primary text-primary-foreground' : 'bg-neutral-100 text-neutral-400',
                    'flex items-center justify-center rounded-md w-7 h-7'
                )
            }>
                <EditIcon className='w-4 h-4'/>
            </button>
        </div>
        
        <div className='flex flex-col gap-2'>
            <div>
                <Label><Trans>Naam</Trans></Label>
                <Input value={intervention?.m_oKLANT.m_sNAAM || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANT:{...intervention.m_oKLANT, m_sNAAM:e.currentTarget.value}}) }} disabled={!is_edit}/>
            </div>
            <div className='flex gap-2'>
                <div className='w-full'>
                    <Label><Trans>Adres</Trans></Label>
                    <Input value={intervention?.m_oKLANT.m_sADRES1 || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANT:{...intervention.m_oKLANT, m_sADRES1:e.currentTarget.value}}) }} disabled={!is_edit} className='w-full'/>
                </div>
                <div>
                    <Label><Trans>Nummer</Trans></Label>
                    <Input value={intervention?.m_oKLANT.m_sNR || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANT:{...intervention.m_oKLANT, m_sNR:e.currentTarget.value}}) }} disabled={!is_edit} className='w-16'/>
                </div>
                <div>
                    <Label><Trans>Bus</Trans></Label>
                    <Input value={intervention?.m_oKLANT.m_sBUS || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANT:{...intervention.m_oKLANT, m_sBUS:e.currentTarget.value}}) }} disabled={!is_edit} className='w-16'/>
                </div>
            </div>
            <div className='flex gap-2'>
                <div>
                    <Label><Trans>Postcode</Trans></Label>
                    <Input value={intervention?.m_oKLANT.m_sPOSTCODE || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANT:{...intervention.m_oKLANT, m_sPOSTCODE:e.currentTarget.value}}) }} disabled={!is_edit} className='w-24'/>
                </div>
                <div className='w-full'>
                    <Label><Trans>Stad</Trans></Label>
                    <Input value={intervention?.m_oKLANT.m_sSTAD || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANT:{...intervention.m_oKLANT, m_sSTAD:e.currentTarget.value}}) }} disabled={!is_edit} className='w-full'/>
                </div>
            </div>
            <div>
                <Label><Trans>Telefoon</Trans></Label>
                <Input value={intervention?.m_oKLANT.m_sRELTEL || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANT:{...intervention.m_oKLANT, m_sRELTEL:e.currentTarget.value}}) }} disabled={!is_edit}/>
            </div>
            <div>
                <Label><Trans>GSM</Trans></Label>
                <Input value={intervention?.m_oKLANT.m_sRELGSM || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANT:{...intervention.m_oKLANT, m_sRELGSM:e.currentTarget.value}}) }} disabled={!is_edit}/>
            </div>
            <div>
                <Label><Trans>E-mailadres</Trans></Label>
                <Input value={intervention?.m_oKLANT.m_sRELEMAIL || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANT:{...intervention.m_oKLANT, m_sRELEMAIL:e.currentTarget.value}}) }} disabled={!is_edit}/>
            </div>
        </div>

        <h3 className={`${styles.h3} mb-4 mt-8`}><Trans>Facturatie</Trans></h3>
        <div className='flex flex-col gap-2'>
            <div>
                <Label><Trans>Naam</Trans></Label>
                <Input value={intervention?.m_oKLANTFACTURATIE.m_sNAAM || ''} disabled/>
            </div>
            <div className='flex gap-2'>
                <div className='w-full'>
                    <Label><Trans>Adres</Trans></Label>
                    <Input value={intervention?.m_oKLANTFACTURATIE.m_sADRES1 || ''} disabled className='w-full'/>
                </div>
                {/* <div>
                    <Label>Nummer</Label>
                    <Input value={''} disabled className='w-16'/>
                </div> */}
                <div>
                    <Label><Trans>Bus</Trans></Label>
                    <Input value={intervention?.m_oKLANTFACTURATIE.m_sBUS || ''} disabled className='w-16'/>
                </div>
            </div>
            <div className='flex gap-2'>
                <div>
                    <Label><Trans>Postcode</Trans></Label>
                    <Input value={intervention?.m_oKLANTFACTURATIE.m_sPOSTCODE || ''} disabled className='w-24'/>
                </div>
                <div className='w-full'>
                    <Label><Trans>Stad</Trans></Label>
                    <Input value={intervention?.m_oKLANTFACTURATIE.m_sSTAD || ''} disabled className='w-full'/>
                </div>
            </div>
            <div>
                <Label><Trans>Telefoon</Trans></Label>
                <Input value={intervention?.m_oKLANTFACTURATIE.m_sTELEFOON || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANTFACTURATIE:{...intervention.m_oKLANTFACTURATIE, m_sTELEFOON:e.currentTarget.value}}) }} disabled={!is_edit}/>
            </div>
            <div>
                <Label><Trans>GSM</Trans></Label>
                <Input value={intervention?.m_oKLANTFACTURATIE.m_sGSM || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANTFACTURATIE:{...intervention.m_oKLANTFACTURATIE, m_sGSM:e.currentTarget.value}}) }} disabled={!is_edit}/>
            </div>
            <div>
                <Label><Trans>E-mailadres</Trans></Label>
                <Input value={intervention?.m_oKLANTFACTURATIE.m_sEMAIL || ''} onChange={(e)=>{ intervention && setintervention({...intervention, m_oKLANTFACTURATIE:{...intervention.m_oKLANTFACTURATIE, m_sEMAIL:e.currentTarget.value}}) }} disabled={!is_edit}/>
            </div>
            <div>
                <Label><Trans>BTW-nummer</Trans></Label>
                <Input value={intervention?.m_oKLANTFACTURATIE.m_sBTWNUMMER || ''} disabled/>
            </div>
        </div>
    </div>
  )
}

export default Customer